<template>
    <div class="all">
        <!-- 筛选 -->
        <div class="screen clearfix">
            <div class="fl">
                <div class="corm fr clearfix">
                    <router-link class="element curr" :to="{path:'./presentationCenter'}">简报列表</router-link>
                    <router-link class="element" :to="{path:'./ordinaryTemplate'}">自定义简报模板</router-link>
                    <router-link class="element" :to="{path:'./timingTemplate'}">定时报告模板</router-link>
                    <router-link class="element" :to="{path:'./timelyReporting'}">定时报告</router-link>
                </div>
            </div>
            <div class="fr">
                <button class="btn btn-jbblue" @click="addNewReport"><i class="icons add-icon"></i>新建普通报告</button>
            </div>
        </div>
        <!-- 预警信息列表 -->
        <div class="warp mt20">
            <div class="warp-body">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="30%">
                        <col width="15%">
                        <col width="20%">
                        <col width="20%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>报告名称</th>
                            <th>创建时间</th>
                            <th>简报状态</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportList" :key="index">
                            <td>{{item.briefdocName}}</td>
                            <td>{{item.createTime}}</td>
                            <td>
                                <div>
                                    <div class="line dib w60" :class="{error:item.status === 5}">
                                        <div class="in" :style="{width:item.progress+'%'}">{{item.status === 5 ? '下载失败' : ''}}</div>
                                    </div>
                                    <span class="color-blue" v-if="item.status != 5" :style="{left:item.progress+'%'}">{{item.progress}}%</span>
                                </div>
                            </td>
                            <td>
                                <div class="table-all-icons">
                                    <span v-if="item.status === 1 || item.status === 2">
										<button class="btn btn-error" @click="cancelDownload(item.id,index)">取消生成</button>
                                    </span>
									<span v-else-if="item.status === 5">
										<button class="btn btn-error" @click="reDownload(item.id,index)">重新生成</button>
									</span>
                                    <span v-else>
                                        <i class="icons eye-icon" title="预览" @click="showhtml(item.htmlUrl)" ></i>
                                        <i class="icons word-icon disabled" title="下载Word" v-if="item.word==''"></i>
                                        <i class="icons word-icon" title="下载Word" @click="downWord(item.word)" v-if="item.word!=''"></i>
                                        <i class="icons pdf-icon disabled" title="下载PDF" v-if="item.pdf==''"></i>
                                        <i class="icons pdf-icon" title="下载PDF" @click="downPdf(item.pdf)" v-if="item.pdf!=''"></i>
                                        <!-- <i class="icons refresh-icon" title="刷新简报" @click="reFresh(item.id)" ></i> -->
                                        <i class="icons send-icon" title="发送简报" @click="sendReport(item.id)" ></i>
                                        <i class="icons del-icon" title="删除简报" @click="delReport(item.id)"></i>
                                    </span>
                                    
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <!-- 分页 -->
                <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <Dialog ref="dialog" title="新建普通模板报告" width="704" btnText="立即生成" :callback="confirm">
            <div slot="mdBox" >
                <h4>tips:<span class="color-red">当前方案不可删除</span></h4>
                <div class="modal-inside mt15 modal-h420">
                    <div class="form-warp name-width0">
                        <div class="item clearfix">
                            <span class="name fl">分析时间：</span>
                            <div class="fl">
                                 <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"  show-buttons  @confirm="selectedDate"/>
                            </div>
                        </div>
                        <div class="item clearfix">
                            <span class="name fl">选择模板：</span>
                            <div class="fl">
                                <span class="drop-down">
                                    <button class="btn btn-lightblue w325"><span class="text">请选择简报模板</span> <i class="icons"></i></button>
                                    <ul class="option ac ">
                                        <vue-scroll :ops="ops" :style="{height:scrollH,width:'100%'}">
                                            <template></template>
                                            <li style="overflow:hidden; text-overflow:ellipsis;white-space:nowrap; width: 161px;" class="wh50 fl" v-for="(item,index) in reportTemplate" :key="index" @click="choseTemple(item.id)" :title="item.tpl_name">{{item.tpl_name}}</li>
                                        </vue-scroll>
                                    </ul>
                                </span>
                            </div>
                        </div>
                        <div class="item clearfix">
                            <span class="name fl">情感属性：</span>
                            <div class="input-father checkbox-group">
                                <label class="checkbox-box">
                                    <label class="checkbox-warp fl" :class="sentiment.indexOf('正面') != -1 ? 'curr' : ''"><input name="" v-model="sentiment" type="checkbox" value="正面" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                    <div class="hidden ac">正面</div>
                                </label>
                                <label class="checkbox-box">
                                    <label class="checkbox-warp fl" :class="sentiment.indexOf('中性') != -1 ? 'curr' : ''"><input name="" v-model="sentiment" type="checkbox" value="中性" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                    <div class="hidden ac">中性</div>
                                </label>
                                <label class="checkbox-box">
                                    <label class="checkbox-warp fl" :class="sentiment.indexOf('负面') != -1 ? 'curr' : ''"><input name="" v-model="sentiment" type="checkbox" value="负面" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                    <div class="hidden ac">负面</div>
                                </label>
                            </div>
                        </div>
                        <div class="item clearfix">
                            <span class="name fl">定向信源：</span>
                            <div class="input-father checkbox-group">
                                <label class="checkbox-box" v-for="(item,index) in configInfo.isFocusList" :key="index">
                                    <label class="checkbox-warp fl" :class="source.indexOf(index) != -1 ? 'curr' : ''">
                                        <input name="" type="checkbox" class="checkbox" v-model="source" :value="index" /> 
                                        <i class="icons checkbox-icon"></i>
                                    </label>
                                    <div class="hidden ac">{{item}}</div>
                                </label>
                            </div>
                        </div>
						<div class="item clearfix">
						    <span class="name fl">匹配模式：</span>
						    <div class="input-father checkbox-group">
						        <label class="checkbox-box" v-for="(item,index) in mateList" :key="index">
						            <label class="checkbox-warp fl" :class="{curr:parseInt(searchMode) === index+1}"><input v-model="searchMode" name="xinyuan" type="radio" :value="index+1" class="radio"> <i class="icons radio-icon"></i></label>
						            <div class="hidden ac">{{item}}</div>
						        </label>
						    </div>
						</div>
                        <div class="item clearfix">
                            <span class="name fl">媒体类型：</span>
                            <div class="input-father checkbox-group">
                                <label class="checkbox-box" v-for="(item,index) in MediaPlatformList" :key="index">
                                    <label class="checkbox-warp fl" :class="{'curr':mediaType.indexOf(index) != -1 }">
                                        <input name="" type="checkbox" class="checkbox" v-model="mediaType" :value="index" /> 
                                        <i class="icons checkbox-icon"></i>
                                    </label>
                                    <div class="ovhidden ac">{{item}}</div>
                                </label>
                            </div>
                        </div>
                        <div class="item clearfix">
                            <span class="name fl">包含方案：</span>
                            <div class="input-father checkbox-group">
                                <label class="checkbox-box caseList" v-for="(item,index) in caseList" :key="index" >
                                    <label class="checkbox-warp fl" @click="delIncloudIndex(item.id,index)" :class="{'curr':caseType.indexOf(item.name) != -1 }">
                                        <input name="" type="checkbox" class="checkbox" v-model="caseType" :value="item.name" :disabled="caseId === item.id ? true : false"/> 
                                        <i class="icons checkbox-icon"></i>
                                    </label>
                                    <div class="ovhidden ac" :title="item.name">{{item.name}}</div>
                                </label>
                            </div>
                        </div>
                        <div class="item clearfix" v-if="includeMainWordList.length>0&&zhutiShow">
                            <span class="name fl">主&nbsp;体&nbsp;词&nbsp;：</span>
                            <div class="input-father checkbox-group">
                                <div  v-for="(item,index) in includeMainWordList" :key="index" class="d-flex" style="flex-wrap:wrap">
                                    <label class="checkbox-box includeWordList" style="display:flex" v-for="(item1,index1) in item.keywords" :key="index1">
                                        <i class="close" @click="delIncloudMainWord(index,index1)" v-if="item.id != caseId">&times;</i>
                                        <div class="ovhidden ac" :title="item1">{{item1}}</div>
                                    </label> 
                                </div>
                            </div>
                        </div>
                        <div class="item clearfix" v-if="includeWordList.length>0&&fenxiShow">
                            <span class="name fl">分&nbsp;析&nbsp;词&nbsp;：</span>
                            <div class="input-father checkbox-group">
                                <div  v-for="(item,index) in includeWordList" :key="index" class="d-flex" style="flex-wrap:wrap">
                                    <label class="checkbox-box includeWordList" style="display:flex" v-for="(item1,index1) in item.keywords" :key="index1">
                                        <i class="close" @click="delIncloudWord(index,index1)" v-if="item.id != caseId">&times;</i>
                                        <div class="ovhidden ac" :title="item1">{{item1}}</div>
                                    </label> 
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog ref="sendDialog" title="发送简报" :callback="sendModal" width="640">
            <div slot="mdBox" >
                <div class="modal-inside">
                    <div class="form-warp name-width0">
                        <div class="item mt10 clearfix report-drop">
                            <span class="name fl">微信:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(1)">
                                <input class="input-text" type="text" placeholder="请点击输入框添加接收人的微信账号" v-model.trim="reportForm.wx" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="wxList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in wxList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedWx.toString().indexOf(item.username+'-'+item.id) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedWx"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac" :title="item.username">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                        <div class="item mt15 clearfix report-drop">
                            <span class="name fl">邮箱:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(2)">
                                <input class="input-text" type="text" placeholder="填写接收人邮箱地址，多个地址请用,隔开" v-model.trim="reportForm.email" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="emailList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in emailList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedEmail.toString().indexOf(item.username+'-'+item.id) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedEmail"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac" :title="item.username">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                        <div class="item mt15 clearfix report-drop">
                            <span class="name fl">手机:</span>
                            <div class="input-father report-btn w325" @click="isHasUser(3)">
                                <input class="input-text" type="text" placeholder="填写接收人手机号码，多个号码请用,隔开，使用短信接收可能会产生额外费用" v-model.trim="reportForm.tel" readonly/>
                            </div>
                            <div class="clearfix report-down" v-if="telList.length>0">
                                <div class="input-father checkbox-group">
                                    <label class="checkbox-box mt10" v-for="(item,index) in telList" :key="index">
                                        <label class="checkbox-warp fl" :class="{'curr':checkedTel.toString().indexOf(item.username+'-'+item.id) != -1 }">
                                            <input name="" type="checkbox" class="checkbox" :value="item.username+'-'+item.id" v-model="checkedTel"/> 
                                            <i class="icons checkbox-icon"></i>
                                        </label>
                                        <div class="ovhidden ac" :title="item.username">{{item.username}}</div>
                                    </label>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog ref="delDialog" :callback="delModal">
            <div slot="mdBox" >
                <div class="ac">确定删除报告吗？</div>
            </div>
        </Dialog>
        <Dialog ref="sendTipDialog" type="alert">
            <div slot="mdBox">
                <vue-scroll :ops="ops" :style="sendTipList.length > 8 ? 'height:168px' : ''">
                    <p v-for="(item,index) in sendTipList" v-html="item" :key="index"></p>
                </vue-scroll>
            </div>
        </Dialog>
	</div>
</template>
<script>
import page from '../../../components/page.vue';
import Dialog from '../../../components/dialog.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
import {mapState} from 'vuex';
export default {
    computed:{
        ...mapState({
            platformList: state => state.show.companyinfo.platformList,
            configInfo: state => state.show.companyinfo
        })
    },
    data() {
        const min = new Date(2019, 5, 1, 0, 0, 0)
        const max = new Date(2019, 8, 30, 0, 0, 0)
        return {
            caseId:'',//当前方案ID
            caseName:'',//当前方案名称
            reportList:[],
            reportListId:[],
            reportTemplate:[],
            currentPage: 1,//当前页码
            limit: 20,//每页显示条数
            totalCount:0,//总条数
            // min: min,
            // max: max,
            startTime:null,
            endTime:null,
            templateId:0,
            reportId:0,
            timeRange: [min, max],
            statusList:[],
            isShow:true,
            MediaPlatformList:[],//媒体类型
            mediaType:['total'],//所选媒体类型
            caseList:[],//所有方案关键词
            caseType:[],//所选方案
            caseNum:0,//所选方案
            curIncloudWord:null,
            currWordList:'',//当前关键词
            currWordMainList:'',//当前主体词
            includeWordList:[],//包含词
            includeMainWordList:[],//主体词
            setTimer:null,
            sentiment:['正面','中性','负面'],//情感属性
            source:[0],//定向信源
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true,
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',

                }
            },
            scrollH:'150px',
            nodata:false,
			mateList:['精准匹配','模糊匹配'],
			searchMode:1,//已选匹配模式
            reportForm:{},
            checkedWx:[],
            curWx:'', 
            curEmail:'', 
            checkedEmail:[],
            curTel:'', 
            checkedTel:[],
            wxList:[],
            emailList:[],
            telList:[],
            sendTipList:[], //发送提示成功
            isShowNew:true,
            zhutiShow:false,
            fenxiShow:false
        }
    },
    components:{
        page,Dialog,VueDatepickerLocal
    },
    created() {
		// 获取缓存方案数据
        this.caseId = JSON.parse(sessionStorage.getItem('planStorage')).id;
        this.caseName = JSON.parse(sessionStorage.getItem('planStorage')).name;
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.initialTime();
            that.dataAjax();
            //that.getMediaType();
            that.getUserMethod('wx');
            that.getUserMethod('email');
            that.getUserMethod('tel');
        })
    },
    watch:{
        caseType(){
            let that = this,nameArr=[],numArr=[],tempArr = [],tempmArr = [];
            that.zhutiShow = false;
            that.fenxiShow = false;
            let len = that.caseType.length;
            if(that.caseNum>len){
                that.isDel = true;
                that.caseNum = len;
                that.delIncloudWords();
                that.delIncloudMainWords();
                return
            }else if(that.caseNum==len){
                return
            }
            that.caseList.forEach((ele,index)=>{
                if(ele.name==that.caseType[len-1]){
                    let temp = {},tempm = {};
                    temp.id = ele.id;
                    tempm.id = ele.id;
                    temp.keywords = [];
                    tempm.keywords = [];
                    ele.keywords_final.forEach(ele1=>{
                        temp.keywords.push(ele1);
                    });
                    ele.keywords_main.forEach(ele1=>{
                        tempm.keywords.push(ele1);
                    });
                    tempArr.push(temp);
                    tempmArr.push(tempm);
                    that.includeWordList.push(temp);
                    that.includeMainWordList.push(tempm);
                }
            });
            that.caseNum = len;
            for(let item of that.includeMainWordList){
                if(item.keywords.length>0){
                    that.zhutiShow = true;
                }
            }
            for(let item of that.includeWordList){
                if(item.keywords.length>0){
                    that.fenxiShow = true;
                }
            }
        },
        mediaType(){
            let that = this;
            let len = that.mediaType.length;
            if(that.mediaType[0] === 'total' && len > 1){//选择非全部 
                that.mediaType.splice(0,1);
            }else if(that.mediaType[len-1] === 'total' && len > 1){
                that.mediaType = ['total'];
            } 
        },
        checkedWx(){
            let that=this,nameArr=[],idArr=[];
            that.checkedWx.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curWx = idArr.toString();
            that.$set(that.reportForm,'wx',tempWx);
        },
        checkedEmail(){
            let that=this,nameArr=[],idArr=[];
            that.checkedEmail.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curEmail = idArr.toString();
            that.$set(that.reportForm,'email',tempWx);
        },
        checkedTel(){
            let that=this,nameArr=[],idArr=[];
            that.checkedTel.forEach((ele,index)=>{
                let tempEle = ele.split('-');
                nameArr.push(tempEle[0])
                idArr.push(tempEle[1])
            });
            let tempWx = nameArr.toString();
            that.curTel = idArr.toString();
            that.$set(that.reportForm,'tel',tempWx);
        },
        platformList:{
            handler(){
                let map_ = new Map();
                for(let item of this.platformList){
                    map_.set(item.type,item.name)
                }
                let obj= Object.create(null);
                for (let[k,v] of map_) {
                    obj[k] = v;
                }
                this.MediaPlatformList = obj;
            },immediate:true
        },
        source(){
            let that = this;
            let len = that.source.length;
            if(that.source[0] === 0 && len > 1){//选择非全部 
                that.source.splice(0,1);
            }else if(that.source[len-1] === 0 && len > 1){
                that.source = [0];
            } 
        },
    },
    beforeDestroy() {
        clearInterval(this.setTimer);
    },
    methods: {
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startTime = this.$utils.dateConversion(min,1);
            this.endTime = this.$utils.dateConversion(max,1);
        },
        dataAjax(){
            let that = this;
            that.reportListId = [];
            clearInterval(this.setTimer);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('report/report/list',{sid:that.caseId,perpage:that.limit,page:that.currentPage},r=>{
                that.$utils.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    r.data.list.forEach(ele=>{
                        if(ele.status!=3 && ele.status != 5){//未完成下载的
                            that.reportListId.push(ele.id);
                        }
                    });
                    that.reportList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata = true;
                        return
                    }else{
                        that.nodata = false;
                    }
                    that.totalCount = Math.floor(r.data.count);
                    that.setTime();
                });
            });
        },
        // 获取媒体类型
        // getMediaType() {
        //     let that = this;
        //     that.mediaType = [];
        //     let datas = {
        //         sid:that.caseId,
        //     };
        //     that.$parent.loadModal(true,'正在获取数据...');
        //     that.$api.post('monitor/analysis/platform', {data:datas}, r => {
        //         that.$utils.returnCode(r,function(){
        //             let data = r.data;
        //             that.$parent.loadModal(false);
        //             // delete r.data.total;
        //             that.mediaTypeList = r.data;
        //         });
        //     })
        // },
        getCaseType() {
            let that = this;
            that.$api.get('report/report/get-all-scheme-info', {sid:that.caseId}, r => {
                that.$utils.returnCode(r,function(){
                    that.caseType.push(that.caseName);
                    let data = r.data.status;
                    that.caseList = data;
                    for(let i of data){//获取当前方案的关键词
                       if(i.name === that.caseName){
                           that.currWordList = i.keywords_final;
                           that.currWordMainList = i.keywords_main
                       }
                    }
                });
            })
        },
        
        // 新建普通模板报告
        addNewReport () {
            let that = this;
            that.mediaType = ['total'];
            that.caseType = [];
            that.includeWordList = [];
            that.includeMainWordList = [];
            that.sentiment = ['正面','中性','负面'],
            that.source = [0],
            that.getCaseType();
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('report/template/get-all-template',null,r=>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.reportTemplate = r.data;
                    if(that.reportTemplate.length<10){
                        that.scrollH = 'auto';
                    }
                    that.$refs.dialog.showMaskFun();
                });
            });
        },
        confirm(){
            let that = this,includeWord=[],includeMainWord=[];
            if(!that.isShowNew){
                that.$utils.alertText('时间跨度最大限制'+this.$store.state.show.companyinfo.timeControlWindow+'天,请重新选择时间','',2000);
                return
            }
            if(that.templateId==0){
                that.$utils.alertText('请选择模板',200);
                return;
            }
            if(that.sentiment.length <= 0){
                that.$utils.alertText('请选择情感属性',200);
                return;
            }
            // if(that.templateId==0){
            //     that.$utils.alertText('请选择模板',200);
            //     return;
            // }
            that.includeWordList.forEach((ele,index)=>{
                ele.keywords.forEach(ele1=>{
                    includeWord.push(ele1);
                });
            });
            let currWordList = that.currWordList;//当前方案关键词
            includeWord = Array.from(new Set(includeWord));
            includeWord = includeWord.concat(currWordList).filter(v => includeWord.includes(v) ^ currWordList.includes(v));
            // if(includeWord.length + currWordList.length>100){
            //     that.$utils.alertText('分析词只能保留100个，请删除多余的分析词',300,2000);
            //     return;
            // }
            let flag =  this.$utils.selectTime([new Date(that.startTime),new Date(that.endTime)],this.$store.state.show.companyinfo.timeControlWindow)
            if(!flag){
                return
            }
            if(that.includeMainWordList.length>0){
                that.includeMainWordList.forEach((ele,index)=>{
                    ele.keywords.forEach(ele1=>{
                        includeMainWord.push(ele1);
                    });
                });
            }else{
                includeMainWord=[]
            }
            
            let currWordMainList = that.currWordMainList;//当前方案关键词
            includeMainWord = Array.from(new Set(includeMainWord));
            includeMainWord = includeMainWord.concat(currWordMainList).filter(v => includeMainWord.includes(v) ^ currWordMainList.includes(v));
            // if(includeMainWord.length + currWordMainList.length>100){
            //     that.$utils.alertText('分析词只能保留100个，请删除多余的分析词',300,2000);
            //     return;
            // }
            let data = {
                "templateId":that.templateId,
                "startTime":that.startTime,
				'searchMode':that.searchMode,
                "endTime":that.endTime,
                "sid":that.caseId,
                "mediaType":that.mediaType,
                "keyWords":includeWord,
                "keywordsMain":includeMainWord,
                "emotion":that.sentiment,
                "isFocus":that.source
            }
            that.$refs.dialog.closeMask();
            clearInterval(that.setTimer);
            that.$parent.loadModal(true,'正在保存...'); 
            that.$api.post('report/report/create',{data:data},r=>{
                that.$utils.returnCode(r,function(){
                    that.$refs.dialog.closeMask();
                    that.$parent.loadModal(false);
                    that.$utils.alertText('添加成功！',200);
                    that.$store.dispatch('show/changeToast',{text:'添加成功！'})
                    that.currentPage = 1;
                    that.dataAjax();
                });
            });
        },
        getTableData() {
           this.dataAjax()
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
            //if(time.getTime() > new Date().getTime()) return true;
        },
		// 重新下载
		reDownload (id,index){
			let that = this;
			that.$api.post('report/report/report-restart',{id:id},r =>{
				that.$utils.returnCode(r,function(){
					// that.list.splice(index,1);
					that.reportList[index].process = 0;
					that.reportList[index].status = 1;
					that.reportListId.push(id);
					that.setTime();
				})
			})
		},
		// 取消下载
		cancelDownload (id,index){
			let that = this;
			that.$confirm('是否取消生成？').then(() => {
				let data = {
					ids:[id]
				}
				that.$api.post('report/report/cancel-report',{data:data},r =>{
					that.$utils.returnCode(r,function(){
						that.reportList.splice(index,1);
						that.reportListId.splice(index,1);
					})
				})
			})
		},
        
        selectedDate (date) {
            let that = this;
            let timeRange = that.timeRange;
            that.isShowNew = true;
            //进页面获取时间数据
            that.startTime = that.$utils.dateConversion(timeRange[0],1);
            that.endTime = that.$utils.dateConversion(timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startTime,that.endTime);
            if(day > this.$store.state.show.companyinfo.timeControlWindow){
                that.$utils.alertText('时间跨度最大限制'+this.$store.state.show.companyinfo.timeControlWindow+'天','',1500);
                that.isShowNew = false;
                return;
            }
        },
        choseTemple(id){
            this.templateId = id;
        },
        //删除报告
        delReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.delDialog.showMaskFun();
        },
        delModal(){
            let that = this;
            that.$refs.delDialog.closeMask();
            that.$parent.loadModal(true,'正在删除...');
            that.$api.get('report/report/delete',{id:that.reportId},r=>{
                that.$utils.returnCode(r,function(){
                    that.dataAjax();
                    that.$utils.alertText('删除成功！',200);
                    that.$store.dispatch('show/changeToast',{text:'删除成功！'})
                    that.currentPage = 1;
                    that.$parent.loadModal(false);
                });
            });
        },
        //刷新报告
        // reFresh(id){
        //     let that = this;
        //      clearInterval(this.setTimer);
        //      that.$api.get('report/report/report-restart',{id:id},r=>{
        //         that.$parent.returnCode(r,function(){
        //             that.reportListId.push(id);
        //             that.setTime();
        //         });
        //     });
        // },
        //发送报告
        sendReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.sendDialog.showMaskFun();
        },
        sendModal(){
            let that = this,contentArr=[];
            if((that.reportForm.wx == undefined ||that.reportForm.wx == '') && (that.reportForm.email == undefined || that.reportForm.email == '')&&(that.reportForm.tel == undefined ||that.reportForm.tel == '')){
                that.$utils.alertText('接收人的微信账号,邮箱地址,手机号码至少填写一项',350,3000);
                return;
            }
            if(that.curWx!=''){
                contentArr.push(that.curWx);
            }
            if(that.curEmail!=''){
                contentArr.push(that.curEmail);
            }
            if(that.curTel!=''){
                contentArr.push(that.curTel);
            }
            let content = contentArr.toString();
            that.$refs.sendDialog.closeMask();
            that.$parent.loadModal(true,'正在发送...'); 
            that.$api.post('report/report/send-report',{rid:that.reportId,contact:content}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    //that.$utils.alertText('发送成功！',150); 
                    that.$refs.sendTipDialog.showMaskFun();
                    that.sendTipList = r.msg;
                })
            });
        },
        //获取微信联系人
        getUserMethod(type){
            let that = this;
            that.$api.get('user/contact/list',{type:type}, r => {
                that.$utils.returnCode(r,function(){
                    if(type==='wx'){
                        that.wxList = r.data;
                    }else if(type==='email'){
                        that.emailList = r.data;
                    }else{
                        that.telList = r.data;
                    }
                })
            });
        },
        isHasUser(type){
            let that = this;
            if(that.wxList=='' && type ==1){
                that.$utils.alertText('请到“我的联系人”添加微信账号！',300);
            }else if(that.emailList=='' && type ==2){
                that.$utils.alertText('请到“我的联系人”添加邮箱地址！',300);
            }else if(that.telList=='' && type ==3){
                that.$utils.alertText('请到“我的联系人”添加手机号码！',300);
            }
        },
        //简报状态
        statusModal(){
            let that = this;
            that.statusList=[];
            let len = that.reportListId.length;
            if(len<=0){
                clearInterval(that.setTimer);
                return
            }
            that.$api.post('report/report/check-status',{sid:this.caseId,id:that.reportListId},r=>{
                that.$utils.returnCode(r,function(){
                    that.statusList = r.data;
                    that.reportList.forEach(ele=>{
                        if(that.statusList[ele.id]!=undefined){
                            ele.progress = that.statusList[ele.id].progress;
                            ele.htmlUrl = that.statusList[ele.id].data.htmlUrl;
                            ele.pdf = that.statusList[ele.id].data.pdf;
                            ele.word = that.statusList[ele.id].data.word;
                            if(that.statusList[ele.id].status === 3 || that.statusList[ele.id].status === 5){//3是生成成功 5是失败
								ele.status = that.statusList[ele.id].status;
                                let ind = that.reportListId.indexOf(ele.id);
                                that.reportListId.splice(ind,1);
                            }
                        }
                        
                    });
                });
            });
        },
        setTime(){
            let that = this;
            that.setTimer = setInterval(function(){
                that.statusModal();
            },1000);
        },
        //下载html
        showhtml(url){
            window.open(url,'_blank')
        },
        //下载word
        downWord(url){
            window.location.href = url;
        },
        //下载pdf
        downPdf(url){
            window.open(url,'_blank')
        },
        delIncloudWord(index,id){
            this.$delete(this.includeWordList[index].keywords,id);
           // this.includeWordList[index].splice(id,1);
        },
        delIncloudMainWord(index,id){
            //console.log(this.includeMainWordList)
            this.$delete(this.includeMainWordList[index].keywords,id);
           //this.includeMainWordList[index].keywordsMain.splice(id,1);
        },
        delIncloudMainWords(){
            let that = this;
            that.includeMainWordList.forEach((ele,index)=>{
		        if(ele.id == that.curIncloudWord){
		            that.includeMainWordList.splice(index,1)
		        }
		    });
            for(let item of that.includeMainWordList){
                if(item.keywords.length>0){
                    that.zhutiShow = true;
                }
            }
        },
        
        delIncloudIndex(id,i){
            let that = this;
            if(id === that.caseId){
                alert();
            }
            that.curIncloudWord = id;
            let len = that.caseType.length;
            let isChose =  $('.caseList .checkbox-warp').eq(i).find('.checkbox').prop('checked');
            if(len>2 && (isChose==true)){
                $('.caseList .checkbox-warp').eq(i).removeClass('curr');
                $('.caseList .checkbox-warp').eq(i).find('.checkbox').prop('checked',false);
                that.$utils.alertText('最多只能选择3个方案哦~',200);
            }
        },
        delIncloudWords(){
            let that = this;
            that.includeWordList.forEach((ele,index)=>{
                if(ele.id==that.curIncloudWord){
                    that.includeWordList.splice(index,1)
                }
            });
            for(let item of that.includeWordList){
                if(item.keywords.length>0){
                    that.fenxiShow = true;
                }
            }
        }
	}
}
</script>
<style scoped>
    .checkbox-group .checkbox-box{margin-right:9px}
    .checkbox-group .checkbox-box:not(.includeWordList):nth-child(5n){margin-right:0}
</style>




// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/presentationCenter.vue